import React, {Component} from 'react';

class IdleModal extends Component {
    render(){
        return (
        <div
            className="modal fade in"
            id="idleModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            style={{display: 'block'}}
        >
            <div
                // className="modal-dialog"
                className={`modal-dialog idle-modal animated flipInX`}
                role="document"
            >
                <div className="modal-content">
                    {/*<div className="timer">*/}
                    {/*<h1>36:06</h1>*/}
                    {/*</div>*/}
                    

                    <div className="modal-body">


                        <div className="text-center" style={{zIndex: 2, position: 'relative'}}>
                            <div>
                                <h3>It seems kind of quiet on your end.<br />Are you still working?</h3>
                                <p>Just a quick reminder that you shouldn’t be attempting lectures at work or at any other place where you’re multitasking - you need to focus just on the lectures</p>
                            </div>
                            <br />
                            <button className="btn btn-success btn-rounded" onClick={e => this.props.continue()}><i className="zmdi zmdi-check" /> Yes, I'm still here</button>
                            <br />
                            
                        </div>
                    </div>
                    
                    


                </div>
            </div>
        </div>
        )
    }
}
export default IdleModal;


// WEBPACK FOOTER //
// ./src/components/Video/IdleModal.js